import { zodResolver } from "@hookform/resolvers/zod";
import { useForm } from "react-hook-form";
import type { FormSupport } from "../types";
import { useFieldController } from "@/hooks/useFieldController";
import { formSupportSchema } from "../schemas";

export const useFormSupport = () => {
  const { control, ...rest } = useForm<FormSupport>({
    resolver: zodResolver(formSupportSchema),
    defaultValues: {
      firstName: "",
      lastName: "",
      email: "",
      phone: "",
      type: "Business",
      businessName: "",
      topic: "",
      message: "",
      agree: false,
       //NOTE: ⚠️ temporary placeholder
       captcha: false,
    },
    reValidateMode: "onChange",
  });

  const firstNameController = useFieldController({
    control,
    name: "firstName",
  });

  const lastNameController = useFieldController({
    control,
    name: "lastName",
  });

  const emailController = useFieldController({
    control,
    name: "email",
  });

  const topicController = useFieldController({
    control,
    name: "topic",
  });

  const phoneController = useFieldController({
    control,
    name: "phone",
  });

  const businessController = useFieldController({
    control,
    name: "businessName",
  });

  const messageController = useFieldController({
    control,
    name: "message",
  });

  const typeController = useFieldController({
    control,
    name: "type",
  });

  const agreeController = useFieldController({
    control,
    name: "agree",
  });

  const captchaController = useFieldController({
    control,
    name: "captcha",
  });

  

  return {
    emailController,
    firstNameController,
    lastNameController,
    phoneController,
    topicController,
    businessController,
    messageController,
    typeController,
    agreeController,
    captchaController,
    ...rest,
  };
};
